/* Enhancements stay outside the existing purchase and quiz flows. */
(() => {
  function setup(root) {
    root.querySelectorAll('[data-hero-video-toggle]').forEach((button) => {
      if (button.dataset.ready) return;
      const video = button.parentElement.querySelector('video');
      if (!video) return;
      button.dataset.ready = 'true';
      const sync = () => {
        button.dataset.state = video.paused ? 'paused' : 'playing';
        button.setAttribute('aria-label', `${video.paused ? 'Play' : 'Pause'} product video`);
      };
      // The film is decorative and 7 MB: phones keep the poster until the viewer presses play, so it is
      // never pulled over mobile data. Wider screens keep the autoplaying loop.
      // On wide screens the loop starts only when the film comes near the screen (it is several MB and
      // often far below the fold), and pauses when it leaves. A film the visitor paused stays paused.
      const autoplayMin = Number(video.dataset.autoplayMin || 0);
      let userPaused = false;
      const start = () => {
        video.preload = 'auto';
        video.play().catch(sync);
      };
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && window.innerWidth >= autoplayMin) {
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                if (!userPaused) start();
              } else if (!video.paused) {
                video.pause();
              }
            });
          }, { rootMargin: '300px 0px' }).observe(video);
        } else {
          start();
        }
      } else {
        video.pause();
      }
      button.addEventListener('click', () => {
        if (video.paused) {
          userPaused = false;
          start();
        } else {
          userPaused = true;
          video.pause();
        }
      });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      sync();
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();

/* Sticky call-to-action for pages without a buy box: shows once the watched element has scrolled
   above the viewport, hides while the offer is on screen. Mirrors SooidSticky in sooid-pdp.js. */
if (typeof customElements !== 'undefined' && !customElements.get('sooid-sticky-link')) {
  customElements.define('sooid-sticky-link', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      // Measured on scroll rather than with IntersectionObserver: the watched button can start
      // inside a hidden container (the quiz result) and be re-rendered later, which an observer
      // bound once at connect never sees.
      let queued = false;
      const update = () => {
        queued = false;
        const watch = document.querySelector(this.dataset.watch || '[data-hero-cta]');
        const until = this.dataset.until ? document.querySelector(this.dataset.until) : null;
        if (!watch || !watch.offsetParent) { this.dataset.visible = 'false'; return; }
        const passed = watch.getBoundingClientRect().bottom < 0;
        const untilRect = until && until.offsetParent ? until.getBoundingClientRect() : null;
        const offerVisible = Boolean(untilRect && untilRect.top < window.innerHeight && untilRect.bottom > 0);
        this.dataset.visible = String(passed && !offerVisible);
      };
      const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      document.addEventListener('sooid:quiz:result', schedule);
      update();
    }
  });
}

/* Before/after result cards: arrows scroll the row one card at a time; dots track the position. */
(() => {
  const setup = (root) => {
    const row = root.querySelector('[data-ba-cards]');
    const prev = root.querySelector('[data-ba-prev]');
    const next = root.querySelector('[data-ba-next]');
    const dots = root.querySelector('[data-ba-dots]');
    if (!row || !prev || !next) return;
    const cards = () => Array.from(row.children);
    const step = () => { const c = cards(); return c.length > 1 ? c[1].offsetLeft - c[0].offsetLeft : row.clientWidth; };
    const index = () => Math.round(row.scrollLeft / Math.max(1, step()));
    const pages = () => Math.max(1, cards().length - Math.max(1, Math.round(row.clientWidth / Math.max(1, step()))) + 1);
    const render = () => {
      const i = index(); const n = pages();
      prev.disabled = i <= 0; next.disabled = i >= n - 1;
      if (dots) {
        if (dots.children.length !== n) dots.replaceChildren(...Array.from({ length: n }, () => document.createElement('span')));
        Array.from(dots.children).forEach((d, k) => { if (k === i) d.setAttribute('data-active', ''); else d.removeAttribute('data-active'); });
      }
    };
    prev.addEventListener('click', () => row.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => row.scrollBy({ left: step(), behavior: 'smooth' }));
    row.addEventListener('scroll', () => requestAnimationFrame(render), { passive: true });
    window.addEventListener('resize', render, { passive: true });
    render();
  };
  const init = () => document.querySelectorAll('[data-ba-carousel]').forEach((root) => { if (!root.dataset.baReady) { root.dataset.baReady = '1'; setup(root); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();


/* Accordions open one item at a time: <details name="…"> does this natively in current browsers; this
   closes the siblings for the rest. A mouse click on a summary must not leave the keyboard focus ring. */
(function () {
  document.addEventListener("toggle", function (event) {
    var item = event.target;
    if (!(item instanceof HTMLDetailsElement) || !item.open || !item.getAttribute("name")) return;
    document.querySelectorAll("details[name=\"" + item.getAttribute("name") + "\"][open]").forEach(function (other) { if (other !== item) other.open = false; });
  }, true);
  document.addEventListener("mousedown", function (event) {
    var summary = event.target.closest && event.target.closest("summary");
    if (summary) summary.classList.add("sooid-no-ring");
  });
  document.addEventListener("keydown", function () {
    document.querySelectorAll("summary.sooid-no-ring").forEach(function (s) { s.classList.remove("sooid-no-ring"); });
  });
})();
